import api from '@/lib/api.js';

var store = {
	namespaced: true,

	state: {
		events: [
			{
				name: 'notes:4',
				condition: 'notes:4',
				triggered: false,
				info: {
					title: 'You have a few notes here',
					content: `Why not group them together? Select them and press the G key to group them up.`
				}
			},
			{
				name: 'notes:6',
				condition: 'notes:6',
				triggered: false,
				info: {
					title: 'Another tip',
					content: `You can press Shift+Enter while writing a note to break it into its own block. Breaking your notes into different blocks will allow them to be dragged individually.`
				}
			},
			{
				name: 'notes:8',
				condition: 'notes:8',
				triggered: false,
				info: {
					title: 'Another tip',
					content: `After selecting a few notes, you can press Del key to delete them.`
				}
			}
		]
	},

	getters: {},

	mutations: {
		UPDATE_EVENTS: function(state, events) {
			state.events = events;
		},
		SET_STATE: function(state, events) {
			state.events = events;
		}
	},

	actions: {
		async init(store) {
			let state = await api.marketing.getState();
			if (state.length < 1) {
				return;
			}
			await store.dispatch('setState', state);
		},
		async setState(store, currentState) {
			let newState = store.state.events.map(event => {
				if (currentState.includes(event.name)) {
					event.triggered = true;
				}
				return event;
			});
			store.commit('SET_STATE', newState);
		},
		async saveState(store) {
			let saveState = [];
			store.state.events.map(event => {
				if (event.triggered) {
					saveState.push(event.name);
				}
			});
			await api.marketing.saveState(saveState);
		},
		async runEvent(store, event) {
			if (event.info && event.info.content) {
				store.dispatch('message/onMessage', event.info, { root: true });
			}
		},
		checkEvents(store) {
			let length = store.rootGetters['block/blocks'].length;
			let change = false;
			let events = store.state.events.map(event => {
				let l = event.condition.split(':')[1];
				l = parseInt(l);
				if (length > l) {
					if (!event.triggered) {
						change = true;
						store.dispatch('runEvent', event);
						event.triggered = true;
					}
				}
				return event;
			});

			if (change) {
				store.commit('UPDATE_EVENTS', events);
				store.dispatch('saveState');
			}
		}
	}
};

export default store;
